<template>
    <span>
        {{ $filters.toCurrency(modelValue) }}
    </span>
</template>

<script>
export default {
    props: {
        modelValue: [Number, String],
    },
};
</script>
